import { Deserializable } from '../deserializable';

export class SystemSetting implements Deserializable {

    id: number;
    module: string;
    setting: string;
    value: string;
    
    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}

